import { Paper } from 'src/design/atoms/Paper';
import groupBy from 'lodash/groupBy';
import React from 'react';
import { Rate } from 'src/api/FiretrolApiClient';
import { RateSheetSection } from './RateSheetSection';

export interface IRateSheetCardProps {
  jobId: number;
  rates: Rate[];
  interactable?: boolean;
}

interface IGroupedRates {
  labor: Rate[];
  equipment: Rate[];
  material: Rate[];
}
export const RateSheetCard: React.FC<IRateSheetCardProps> = ({
  jobId,
  rates,
  interactable = false,
}) => {
  const [groupedRates, setGroupedRates] = React.useState<IGroupedRates>({
    labor: [],
    equipment: [],
    material: [],
  });
  React.useEffect(() => {
    const grouped = groupBy(rates, 'category');
    const obj = {
      labor: grouped.labor || [],
      equipment: grouped.equipment || [],
      material: grouped.material || [],
    };
    setGroupedRates(obj);
  }, [rates]);

  return (
    <Paper p="md" withBorder>
      <h3 style={{ marginBottom: 10, marginTop: 0 }}>Company Rate Sheet</h3>
      <RateSheetSection
        title="Labor Type"
        interactable={interactable}
        rates={groupedRates.labor}
        category="labor"
        jobId={jobId}
        measurement="hr"
      />
      <hr style={{ marginTop: 15 }} />
      <RateSheetSection
        title="Equipment"
        interactable={interactable}
        rates={groupedRates.equipment}
        category="equipment"
        jobId={jobId}
        measurement="hr"
      />
      <hr style={{ marginTop: 15 }} />
      <RateSheetSection
        title="Material"
        interactable={interactable}
        rates={groupedRates.material}
        category="material"
        jobId={jobId}
        measurement="cy"
      />
    </Paper>
  );
};
